import { VariationItemModel } from "../../models";

export function mockVariationItemModel({
    id = "variation-container-1234",
    type = "variationItem",
    locale = "en",
    content = mockVariationItemModelContent()
}: Partial<VariationItemModel> = {}): VariationItemModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type VariationItemModelContent = VariationItemModel["content"];

export function mockVariationItemModelContent({
    entryTitle = "Variation Item Example",
    variationValue = "EXPCEN-0000-var1",
    variationName = "bxptFeatureFlagExample",
    variation = [],
    ...optionals
}: Partial<VariationItemModelContent> = {}): VariationItemModelContent {
    return {
        entryTitle,
        variationValue,
        variationName,
        variation,
        ...optionals
    };
}
